import { ThemeProvider } from "@mui/material";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import HOC from "../../../components/HOC";
import InboxWarehouseList from "../../../components/screen/centralWarehouse/inbox/InboxWarehouseList";
import { theme } from "../../../components/constants/muiTheme";

const InboxWarehousePage = ({ type }) => {
  return (
    <div className="">
      <PageTemplate
        header={"Inbox " + (Number(type) === 1 ? "Warehouse" : "Outlet")}
        mainComponent={
          <ThemeProvider theme={theme}>
            <InboxWarehouseList type={type} />
          </ThemeProvider>
        }
        pageRole={type === 1 ? 39 : 40}
      />
    </div>
  );
};

export default HOC(InboxWarehousePage);
